{
    "accept": "Akzeptieren",
    "action_open_in_external_app": "In ${1} öffnen",
    "back": "Zurück",
    "cancel": "Abbrechen",
    "choose": "Auswählen",
    "client_timeout_error_description": "Wir konnten deine Anfrage aufgrund einer Zeitüberschreitung der Verbindung nicht abschließen. Bitte überprüfe deine Verbindung und versuche es erneut. Wenn das Problem weiterhin besteht, wende dich an unser Support-Team.",
    "content_missing": "Inhalt konnte nicht gefunden werden.",
    "delete": "Löschen",
    "description": "Beschreibung",
    "dismiss": "Verwerfen",
    "done": "Fertig",
    "donor_feedback_anonymized": "Aus Datenschutzgründen haben wir Ihre Daten bereits anonymisiert.",
    "donor_feedback_incorrect_link": "Der von Ihnen verwendete Link ist nicht korrekt - bitte stellen Sie sicher, dass Sie den vollständigen Link verwenden, der Ihnen zugesandt wurde.",
    "donor_feedback_not_found": "Dieser Link ist leider ungültig, dies kann einen der folgenden Gründe haben:",
    "error_occurred": "Ein Fehler ist aufgetreten",
    "expired": "Abgelaufen",
    "failed": "Nicht bestanden",
    "field_error_address_unsupported_country": "Adresse befindet sich nicht in erlaubten Land",
    "field_error_any": "Eines dieser Felder muss ausgefüllt werden: ${1}",
    "field_error_date_invalid": "Das Datum ist ungültig",
    "field_error_date_max": "Das Geburtsdatum muss vor dem ${1} liegen",
    "field_error_date_min": "Das Geburtsdatum muss nach dem ${1} liegen",
    "field_error_date_range_max": "Das Datum muss vor dem ${1} liegen",
    "field_error_date_range_min": "Das Datum muss nach dem ${1} liegen",
    "field_error_email": "Die E-Mail-Adresse ist ungültig",
    "field_error_length_max": "Die Eingabe darf maximal ${1} Zeichen lang sein",
    "field_error_length_min": "Die Eingabe muss mindestens ${1} Zeichen lang sein",
    "field_error_max": "Der maximale Spendenbeitrag ist ${1}",
    "field_error_min": "Der Mindestspendenbeitrag ist ${1}",
    "field_error_pattern": "Die Eingabe ist ungültig",
    "field_error_phone_invalid": "Die Telefonnummer ist ungültig",
    "field_error_phone_starts_with_zero": "Eine Ländervorwahl existiert bereits. Bitte entfernen Sie die führende „0\" aus der Telefonnummer.",
    "field_error_required": "Das Feld muss ausgefüllt werden",
    "field_is_required": "Dieses Feld ist verpflichtend",
    "field_placeholder_address_search": "Gib einen Ort ein",
    "field_select_not_found": "'${1}' wurde nicht gefunden",
    "font_big": "große Schrift",
    "font_medium": "mittlere Schrift",
    "font_small": "kleine Schrift",
    "last_attempt": "Letzter Versuch",
    "last_upload": "Letzter Upload",
    "link_sent": "Link wurde versendet, bitte überprüfen Sie",
    "network_error": "Netzwerkfehler",
    "next": "Weiter",
    "no_results": "Keine Resultate",
    "offline": "offline",
    "ok": "OK",
    "online": "online",
    "open": "Öffnen",
    "page_not_found_description": "Die Seite die du aufrufen wolltest, gibt es nicht. Vielleicht hast du dich bei der URL vertippt?",
    "page_not_found_link": "Zurück zur Startseite.",
    "page_not_found_title": "Seite Nicht Gefunden",
    "pagination_result": "${1} - ${2} von ${3} Ergebnissen",
    "passed": "Bestanden",
    "request_support": "Support anfragen",
    "request_support_error_title": "Anfrage fehlgeschlagen",
    "request_support_success_description": "Wir haben deine Support Anfrage erhalten.",
    "request_support_success_title": "Anfrage eingelangt",
    "result": "Ergebnis",
    "retry": "Wiederholen",
    "save": "Sichern",
    "send_a_support_request": "Support Anfrage",
    "server_unexpected_error_description": "Auf unserer Seite ist etwas schiefgelaufen. Bitte versuche es in einem Moment erneut. Wenn das Problem weiterhin besteht, wend dich bitte an unseren Support.",
    "state_done": "Erledigt",
    "state_not_uploaded": "Nicht hochgeladen",
    "state_pending": "Ausstehend",
    "state_refused": "Abgelehnt",
    "state_uploading": "wird hochgeladen",
    "submit": "Übermitteln",
    "support_request_type": "Art der Anfrage",
    "type": "Typ",
    "uploading": "Hochladen..."
}